




























import { defineComponent, PropType } from '@nuxtjs/composition-api';
import AppAvatar from '~/components/partials/App/AppAvatar.vue';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { STAFF_REVIEW_ANCHOR_POINT } from '~/constants';

export default defineComponent({
  components: {
    AppAvatar,
    AppLink,
    AppIcon,
  },
  props: {
    staffIcons: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    isOverThree: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return { STAFF_REVIEW_ANCHOR_POINT };
  },
});
